<div [id]="'chart-container'+id"  [style]="'height:'+height"></div>
